"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorDistrictCodeResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const shared_1 = require("../shared");
class BehaviorDistrictCodeResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'code',
            'description',
            'passMessage',
            'printPass',
            'active',
            'type',
            'behaviorCodeTypeId',
            'fastTrack',
            'externalReferenceCode',
            'schoolGroup'
        ];
    }
    id;
    code;
    description;
    passMessage;
    printPass;
    active;
    type;
    behaviorCodeTypeId;
    fastTrack;
    schoolGroup;
    externalReferenceCode;
    static mapBehaviorCodes(entities) {
        return mappable_base_1.MappableBase.mapAll(entities, BehaviorDistrictCodeResponseDto);
    }
}
exports.BehaviorDistrictCodeResponseDto = BehaviorDistrictCodeResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorDistrictCodeResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorDistrictCodeResponseDto.prototype, "code", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    __metadata("design:type", String)
], BehaviorDistrictCodeResponseDto.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(250),
    __metadata("design:type", String)
], BehaviorDistrictCodeResponseDto.prototype, "passMessage", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeResponseDto.prototype, "printPass", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeResponseDto.prototype, "active", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], BehaviorDistrictCodeResponseDto.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorDistrictCodeResponseDto.prototype, "behaviorCodeTypeId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BehaviorDistrictCodeResponseDto.prototype, "fastTrack", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", shared_1.RelationDto)
], BehaviorDistrictCodeResponseDto.prototype, "schoolGroup", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(50),
    __metadata("design:type", String)
], BehaviorDistrictCodeResponseDto.prototype, "externalReferenceCode", void 0);
